import React from 'react';
import '../css/About.css'; 
import { Container, Row, Col, Image } from 'react-bootstrap';
import about1 from '../images/AboutUs-1.jpeg';
import about2 from '../images/AboutUs-2.jpeg';

const About = () => {
  return (
    <Container className='about-container'>
      <Row className="about-us-section">
        <h1 className="about-title">About Us</h1>

        <Row className="about-row align-items-center">
          {/* Image on the left */}
          <Col xs={12} md={5} className="about-image-col">
            <Image
              src={about1}
              alt="Placeholder"
              className="about-image"
              fluid
            />
          </Col>

          {/* Text on the right */}
          <Col xs={12} md={7} className="about-text-col">
            <p className="about-paragraph">
              At <strong>FarmHouse Media and Consulting</strong>, we specialize in providing comprehensive web development and services tailored for small businesses in Eastern North Carolina. Our expertise includes creating stunning websites, developing custom applications, and delivering seamless integrations that optimize your business operations. Additionally, we offer business consulting services designed to help local businesses navigate challenges and achieve growth in today’s competitive digital landscape.
            </p>
            <p className="about-paragraph">
              We understand the unique challenges small business owners face, whether you are establishing a web presence or seeking to leverage technology and expertise to grow your business. Our dedicated team is committed to helping you navigate the complexities of the online world, ensuring that your business not only meets market demands but also stands out in a competitive environment. Whether you're looking to launch your first website or enhance your existing online strategy, we are here to support you every step of the way.
            </p>
          </Col>
        </Row>

        <Row className="about-row align-items-center">
          {/* Image on the right for desktop, above text for mobile */}
          <Col xs={12} md={5} className="about-image-col order-1 order-md-2">
            <Image
              src={about2}
              alt="Placeholder"
              className="about-image about-image-circular"
              fluid
            />
          </Col>
          {/* Text on the left for desktop, below image for mobile */}
          <Col xs={12} md={7} className="about-text-col order-2 order-md-1">
            <p className="about-paragraph">
              With over 10 years of experience in IT support and development, our team is passionate about cultivating strong relationships and fostering innovation to drive success. We strive to deliver tailored solutions that not only align with your business goals but also inspire growth and transformation.
              At FarmHouse Media and Consulting, your success is at the heart of everything we do. We believe in creating meaningful partnerships and empowering businesses to thrive in a rapidly evolving digital landscape. Our customer-centric approach ensures that we listen, adapt, and deliver solutions that truly make a difference. Together, let’s build a future where your business can flourish in the digital age.
            </p>
          </Col>
        </Row>


        <section className="why-us-section">
          <h3>Why Choose FarmHouse Media and Consulting?</h3>
          <ul className="why-us-list">
            <li>
              <strong>Building Your Digital Identity:</strong>
              <p>Crafting visually stunning, user-friendly websites tailored to your unique needs.</p>
            </li>
            <li>
              <strong>Innovating for Success:</strong>
              <p>Delivering custom applications and integrations to streamline your operations and foster growth.</p>
            </li>
            <li>
              <strong>Your Growth, Our Mission:</strong>
              <p>Providing actionable insights and strategies to help your business thrive in a competitive market.</p>
            </li>
            <li>
              <strong>Seamless Collaboration:</strong>
              <p>Partnering with you to create solutions that are as dynamic and adaptable as your business.</p>
            </li>
          </ul>
        </section>


      </Row>
    </Container>

  );
};

export default About;
